import React from 'react';

import { IconButton } from '@mui/material';
import { AlineTooltip, useCopyDocLink } from 'src/components';
import { LinkIcon } from 'src/components/icons/LinkIcon';

interface CopyDocLinkButtonProps {
  documentId: UUID;
  disabled?: boolean;
}

export function CopyDocLinkButton({ disabled, documentId }: CopyDocLinkButtonProps): JSX.Element {
  const { copyDocLink } = useCopyDocLink();

  return (
    <AlineTooltip arrow placement="bottom" title="Copy document link">
      <div>
        <IconButton disabled={disabled} size="small" onClick={() => copyDocLink(documentId)}>
          <LinkIcon />
        </IconButton>
      </div>
    </AlineTooltip>
  );
}
